import { track } from "@amplitude/analytics-browser";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment as env } from "@environments/environment";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-mainpage",
  templateUrl: "./mainpage.component.html",
  styleUrls: ["./mainpage.component.scss", "../../landing.component.scss"],
})
export class MainpageComponent implements OnInit {
  constructor(private router: Router) {}
  mainHeroeURL = 'assets/landing/images/main-heroe-es.gif';
  country = env.lang;

  private availableCarouselItems = [
    {
      index: 0,
      image: "assets/landing/images/main-carousel-1.png",
      title: "LANDING.MAINPAGE.CAROUSEL.C1_TITLE",
      subtitle: "LANDING.MAINPAGE.CAROUSEL.C1_SUBTITLE",
    },
    {
      index: 1,
      image: "assets/landing/images/main-carousel-2.png",
      title: "LANDING.MAINPAGE.CAROUSEL.C2_TITLE",
      subtitle: "LANDING.MAINPAGE.CAROUSEL.C2_SUBTITLE",
    },
    {
      index: 2,
      image: "assets/landing/images/main-carousel-3.png",
      title: "LANDING.MAINPAGE.CAROUSEL.C3_TITLE",
      subtitle: "LANDING.MAINPAGE.CAROUSEL.C3_SUBTITLE",
    },
    {
      index: 3,
      image: "assets/landing/images/main-carousel-4.png",
      title: "LANDING.MAINPAGE.CAROUSEL.C4_TITLE",
      subtitle: "LANDING.MAINPAGE.CAROUSEL.C4_SUBTITLE",
    },
    {
      index: 4,
      image: "assets/landing/images/main-carousel-5.png",
      title: "LANDING.MAINPAGE.CAROUSEL.C5_TITLE",
      subtitle: "LANDING.MAINPAGE.CAROUSEL.C5_SUBTITLE",
    },
    {
      index: 5,
      image: "assets/landing/images/main-carousel-6.png",
      title: "LANDING.MAINPAGE.CAROUSEL.C6_TITLE",
      subtitle: "LANDING.MAINPAGE.CAROUSEL.C6_SUBTITLE",
    },
  ];

  public benefits = {
    visibility: [
      {
        icon: 'assets/landing/images/benefits/visibility/vis_1.svg',
        label: 'LANDING.BENEFITS.VISIBILITY.VIS_1'
      },
      {
        icon: 'assets/landing/images/benefits/visibility/vis_2.svg',
        label: 'LANDING.BENEFITS.VISIBILITY.VIS_2'
      },
      {
        icon: 'assets/landing/images/benefits/visibility/vis_3.svg',
        label: 'LANDING.BENEFITS.VISIBILITY.VIS_3'
      },
      {
        icon: 'assets/landing/images/benefits/visibility/vis_4.svg',
        label: 'LANDING.BENEFITS.VISIBILITY.VIS_4'
      },
      {
        icon: 'assets/landing/images/benefits/visibility/vis_5.svg',
        label: 'LANDING.BENEFITS.VISIBILITY.VIS_5'
      },
    ],
    special: [
      {
        icon: 'assets/landing/images/benefits/especial/esp_1.svg',
        label: 'LANDING.BENEFITS.SPECIAL.SPE_1'
      },
      {
        icon: 'assets/landing/images/benefits/especial/esp_2.svg',
        label: 'LANDING.BENEFITS.SPECIAL.SPE_2'
      },
      {
        icon: 'assets/landing/images/benefits/especial/esp_3.svg',
        label: 'LANDING.BENEFITS.SPECIAL.SPE_3'
      },
      {
        icon: 'assets/landing/images/benefits/especial/esp_4.svg',
        label: 'LANDING.BENEFITS.SPECIAL.SPE_4'
      },
      {
        icon: 'assets/landing/images/benefits/especial/esp_5.svg',
        label: 'LANDING.BENEFITS.SPECIAL.SPE_5'
      },
      {
        icon: 'assets/landing/images/benefits/especial/esp_6.svg',
        label: 'LANDING.BENEFITS.SPECIAL.SPE_6'
      },
    ],
    security: [
      {
        icon: 'assets/landing/images/benefits/security/sec_1.svg',
        label: 'LANDING.BENEFITS.SECURITY.SEC_1'
      },
      {
        icon: 'assets/landing/images/benefits/security/sec_2.svg',
        label: 'LANDING.BENEFITS.SECURITY.SEC_2'
      },
      {
        icon: 'assets/landing/images/benefits/security/sec_3.svg',
        label: 'LANDING.BENEFITS.SECURITY.SEC_3'
      },
      {
        icon: 'assets/landing/images/benefits/security/sec_4.svg',
        label: 'LANDING.BENEFITS.SECURITY.SEC_4'
      },
      {
        icon: 'assets/landing/images/benefits/security/sec_5.svg',
        label: 'LANDING.BENEFITS.SECURITY.SEC_5'
      },
      {
        icon: 'assets/landing/images/benefits/security/sec_6.svg',
        label: 'LANDING.BENEFITS.SECURITY.SEC_6'
      },
    ],
    others: [
      {
        icon: 'assets/landing/images/benefits/others/oth_1.svg',
        label: 'LANDING.BENEFITS.OTHERS.OTH_1'
      },
      {
        icon: 'assets/landing/images/benefits/others/oth_2.svg',
        label: 'LANDING.BENEFITS.OTHERS.OTH_2'
      },
      {
        icon: 'assets/landing/images/benefits/others/oth_3.svg',
        label: 'LANDING.BENEFITS.OTHERS.OTH_3'
      }
    ]
}

  selectedCarousel$: BehaviorSubject<typeof this.availableCarouselItems[0]> = new BehaviorSubject(this.availableCarouselItems[0]);

  changeSelectedCarousel(index: number, direction: number) {
    const newPos = index + direction;
    if (newPos < 0) {
      this.selectedCarousel$.next(this.availableCarouselItems[this.availableCarouselItems.length - 1]);
    } else if (!this.availableCarouselItems[newPos]) {
      this.selectedCarousel$.next(this.availableCarouselItems[0]);
    } else  {
      this.selectedCarousel$.next(this.availableCarouselItems[newPos]);
    }
  }

  clickCta() {
    this.router.navigate(['home/contact']);
    track('LANDING_CTA_CLICKED');
  }

  ngOnInit(): void {
    if (env.lang === 'pt') {
      this.mainHeroeURL = 'assets/landing/images/main-heroe-pt.png'
    }
  }
}
